import { render, staticRenderFns } from "./ChatDetailPage.vue?vue&type=template&id=501cc6cf&scoped=true"
import script from "./ChatDetailPage.vue?vue&type=script&lang=js"
export * from "./ChatDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ChatDetailPage.vue?vue&type=style&index=0&id=501cc6cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501cc6cf",
  null
  
)

export default component.exports